<template>
    <div class="documentation">
        <!-- <p class="title">成功案例</p> -->
        <el-row type="flex"
                class="row-bg head"
                justify="center">
            <el-col :span="20"
                    class="middle">
                <el-col class="main"
                        :span="6"
                        v-for="(item,index) in mainlist"
                        :key="index">
                    <div class="inner"
                         @click="toJournalism(item)"> <img :src="item.image" />
                        <p class="big">{{item.title}}</p>
                        <p class="Single ">{{item.created|formatDateMin}}</p>
                        <div class="hide">
                            <p class="Promise">{{item.description}}</p>
                        </div>
                    </div>
                </el-col>
                <!-- <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col>
                <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col>
                <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col>
                <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col>
                <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col>
                <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col>
                <el-col class="main"
                        :span="6">
                    <div class="inner"> <img src="@/assets/images/fazhanlicheng.png" />
                        <p class="big">半年干出好成绩，TA的秘诀</p>
                        <p class="Single ">2018-12-26 19:36:47</p>
                        <p class="Promise">您好！据中央气象台最新预报，未来三天，陕西南部重庆东南部、湖北南部、湖南西部和北部、贵州中东部江部、货物中转...</p>
                    </div>
                </el-col> -->
            </el-col>
        </el-row>
        <div class="block">
            <el-pagination background=""
                           @current-change="handleCurrentChange"
                           :current-page="ruleForm.currentPage"
                           :page-sizes="[10, 20, 50]"
                           :page-size="ruleForm.pageSize"
                           layout="total,prev, pager, next"
                           :total="ruleForm.total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { queryarticle } from "@/api/homePage";
import { mapGetters } from "vuex";
export default {
    name: "business",
    data() {
        return {
            mainlist: [],
            ruleForm: {
                data: {
                    categoryId: ""
                },
                currentPage: 1,
                total: 0,
                pageSize: 8
            }
        };
    },
    computed: {},
    created() {
        this.search(1);
    },
    methods: {
        search(val) {
            this.ruleForm.data.categoryId = this.$route.query.id;
            this.ruleForm.pageIndex = val;
            queryarticle(this.ruleForm)
                .then(res => {
                    if (res.status === 2000) {
                        this.mainlist = res.data;
                        this.ruleForm.total = res.total;
                    }
                })
                .catch(err => {});
        },
        toJournalism(data) {
            this.$router.push(
                {
                    path: "/Journalism",
                    query: {
                        id: this.ruleForm.data.categoryId,
                        contentid: data.id
                    }
                }
                // "/Journalism?id=722F12B9-BBC1-B4D0-16CD-7E82446428C4"
            );
        },
        handleCurrentChange(val) {
            this.search(val);
        }
    }
};
</script>
<style lang="scss" scoped>
.documentation {
    padding-bottom: 59px;
    padding-top: 20px;
    background-color: #fff;
    .head {
        .middle {
            // display: flex;
            // flex-direction: row;
            // flex-wrap: wrap;
            // justify-content: center;
            overflow: hidden;
            .main {
                margin-top: 50px;
                margin-bottom: 10px;
                padding: 0 10px;
                // border: 1px solid #ccc;
                .inner {
                    cursor: pointer;
                    box-shadow: 0px 0px 7px 1px #e8e8e8;
                    padding-bottom: 10px;
                }
                img {
                    width: 100%;
                    // max-height: 170px;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    // min-height: 300px;
                }
                p {
                    padding: 0 15px;
                    color: #333;
                }
                .big {
                    cursor: pointer;
                    font-size: 16px;
                    margin-top: 14px;
                }
                .Single {
                    font-size: 14px;
                    margin-top: 15px;
                    margin-top: 14px;
                }
                .hide {
                    height: 60px;
                    margin-top: 15px;
                    overflow: hidden;
                    .Promise {
                        font-size: 14px;
                        color: #777777;
                        padding: 0 15px;
                        margin-bottom: 10px;
                        line-height: 21px;
                    }
                }
            }
        }
    }
    .block {
        margin-top: 20px;
        .el-pagination {
            text-align: center;
            margin-top: 60px;
        }
        /deep/ .el-pagination.is-background .el-pager li {
            border-radius: 15px;
        }
        /deep/ .el-pagination.is-background .btn-prev,
        /deep/ .el-pagination.is-background .btn-next {
            border-radius: 15px;
        }
    }
}
</style>
